/** regex source: https://stackoverflow.com/a/57342060/2420102 */
export const realNumberRegex = /^\s*[+-]?(\d+|\d*[.,]\d+|\d+[.,]\d*)([Ee][+-]?\d+)?\s*$/;

export const realNumberRegexTwoDec = /^\s*[+-]?(\d+|\d*[.,]\d{1,2}|\d+[.,]\d{1,2})\s*$/;

/** reference: https://stackoverflow.com/a/3809435/2420102  */
export const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
